/* TFP 4.0 — movimiento, menús y micro-interacciones */
(function () {
  var K = 1, io = null, raf = null, nav = null, bar = null, parallax = [], lastY = 0, navHidden = false, timeline = null, tlfill = null;

  function setupMenus() {
    document.querySelectorAll("[data-menu]").forEach(function (menu) {
      var panel = menu.querySelector("[data-panel]");
      if (!panel) return;
      var open = function () { panel.style.opacity = "1"; panel.style.visibility = "visible"; panel.style.transform = "translateY(0)"; };
      var close = function () { panel.style.opacity = "0"; panel.style.visibility = "hidden"; panel.style.transform = "translateY(-8px)"; };
      menu.addEventListener("mouseenter", open);
      menu.addEventListener("mouseleave", close);
      menu.addEventListener("focusin", open);
      menu.addEventListener("focusout", close);
    });
  }

  function setupCards() {
    document.querySelectorAll("[data-prod]").forEach(function (card) {
      var img = card.querySelector("[data-prodimg]");
      var cta = card.querySelector("[data-prodcta]");
      card.addEventListener("mouseenter", function () {
        if (img) { img.style.transform = "scale(1.06)"; img.style.filter = "grayscale(0) contrast(1.04) saturate(.9)"; }
        if (cta) cta.style.gap = "18px";
      });
      card.addEventListener("mouseleave", function () {
        if (img) { img.style.transform = "scale(1)"; img.style.filter = "grayscale(1) contrast(1.04)"; }
        if (cta) cta.style.gap = "10px";
      });
    });
  }

  function setupMobileNav() {
    var header = document.querySelector("[data-nav]");
    if (!header || document.querySelector("[data-drawer]")) return;
    var bar = header.firstElementChild;
    var nav = header.querySelector("nav");
    if (!bar || !nav) return;
    var cta = bar.querySelector(":scope > a:last-of-type");

    var btn = document.createElement("button");
    btn.setAttribute("data-navtoggle", "");
    btn.setAttribute("aria-label", "Abrir menú");
    btn.setAttribute("aria-expanded", "false");
    btn.style.cssText = "display:none; margin-left:auto; width:48px; height:48px; align-items:center; justify-content:center; flex-direction:column; gap:5px; background:transparent; border:1px solid rgba(242,242,243,.24); cursor:pointer; padding:0; flex:0 0 auto;";
    btn.innerHTML = '<i style="display:block; width:20px; height:1.5px; background:#f2f2f3; transition:transform .3s ease, opacity .3s ease;"></i><i style="display:block; width:20px; height:1.5px; background:#f2f2f3; transition:transform .3s ease, opacity .3s ease;"></i><i style="display:block; width:20px; height:1.5px; background:#f2f2f3; transition:transform .3s ease, opacity .3s ease;"></i>';
    bar.appendChild(btn);

    var dr = document.createElement("div");
    dr.setAttribute("data-drawer", "");
    dr.style.cssText = "position:fixed; inset:0; z-index:70; background:#0e0f10; display:none; flex-direction:column; opacity:0; transition:opacity .3s ease; overflow-y:auto; -webkit-overflow-scrolling:touch;";

    var head = document.createElement("div");
    head.style.cssText = "display:flex; align-items:center; justify-content:space-between; padding:0 22px; height:70px; border-bottom:1px solid rgba(242,242,243,.14); flex:0 0 auto;";
    var logo = header.querySelector("img");
    head.innerHTML = '<span style="font-family:\'Barlow Condensed\', system-ui, sans-serif; font-size:12px; letter-spacing:.24em; text-transform:uppercase; color:#5d5d60;">Menú</span>';
    var close = document.createElement("button");
    close.setAttribute("aria-label", "Cerrar menú");
    close.style.cssText = "width:48px; height:48px; background:transparent; border:1px solid rgba(242,242,243,.24); color:#f2f2f3; font-size:22px; line-height:1; cursor:pointer;";
    close.textContent = "\u00d7";
    head.appendChild(close);
    dr.appendChild(head);

    var list = document.createElement("div");
    list.style.cssText = "display:flex; flex-direction:column; padding:8px 0 28px;";
    var mkLink = function (href, label, meta, sub) {
      var a = document.createElement("a");
      a.href = href || "#";
      a.style.cssText = "display:flex; align-items:center; justify-content:space-between; gap:16px; min-height:" + (sub ? "48px" : "58px") + "; padding:" + (sub ? "12px 22px 12px 40px" : "14px 22px") + "; border-bottom:1px solid rgba(242,242,243,.07); font-family:'Barlow Condensed', system-ui, sans-serif; text-transform:uppercase; letter-spacing:" + (sub ? ".08em" : ".12em") + "; font-size:" + (sub ? "15px" : "19px") + "; color:" + (sub ? "#b7b7ba" : "#f2f2f3") + ";";
      var s = document.createElement("span");
      s.textContent = label;
      a.appendChild(s);
      if (meta) {
        var m = document.createElement("span");
        m.textContent = meta;
        m.style.cssText = "font-size:11px; letter-spacing:.18em; color:#5d5d60;";
        a.appendChild(m);
      }
      list.appendChild(a);
      return a;
    };
    var clean = function (el) {
      return (el.textContent || "").replace(/[\u25be\u25b8\u2192]/g, "").trim();
    };
    Array.prototype.forEach.call(nav.children, function (child) {
      if (child.tagName === "A") {
        mkLink(child.getAttribute("href"), clean(child), "", false);
      } else {
        var top = child.querySelector(":scope > a");
        var panel = child.querySelector("[data-panel]");
        if (top) mkLink(top.getAttribute("href"), clean(top), "", false);
        if (panel) Array.prototype.forEach.call(panel.querySelectorAll("a"), function (a) {
          var sp = a.querySelectorAll("span");
          var label = sp.length ? clean(sp[0]) : clean(a);
          var meta = sp.length > 1 ? clean(sp[1]) : "";
          mkLink(a.getAttribute("href"), label, meta, true);
        });
      }
    });
    dr.appendChild(list);

    if (cta) {
      var wrap = document.createElement("div");
      wrap.style.cssText = "padding:4px 22px 32px; margin-top:auto;";
      var big = document.createElement("a");
      big.href = cta.getAttribute("href") || "#";
      big.style.cssText = "display:flex; align-items:center; justify-content:space-between; min-height:58px; padding:0 24px; background:#ff6a00; color:#0e0f10; font-family:'Barlow Condensed', system-ui, sans-serif; font-size:17px; letter-spacing:.16em; text-transform:uppercase;";
      big.innerHTML = "<span>" + clean(cta) + "</span><span>&#8594;</span>";
      wrap.appendChild(big);
      dr.appendChild(wrap);
    }
    document.body.appendChild(dr);

    var open = false;
    var bars = btn.querySelectorAll("i");
    var set = function (v) {
      open = v;
      btn.setAttribute("aria-expanded", v ? "true" : "false");
      btn.setAttribute("aria-label", v ? "Cerrar menú" : "Abrir menú");
      document.documentElement.style.overflow = v ? "hidden" : "";
      document.body.style.overflow = v ? "hidden" : "";
      bars[0].style.transform = v ? "translateY(6.5px) rotate(45deg)" : "";
      bars[1].style.opacity = v ? "0" : "1";
      bars[2].style.transform = v ? "translateY(-6.5px) rotate(-45deg)" : "";
      if (v) {
        dr.style.display = "flex";
        requestAnimationFrame(function () { dr.style.opacity = "1"; });
      } else {
        dr.style.opacity = "0";
        setTimeout(function () { if (!open) dr.style.display = "none"; }, 300);
      }
    };
    btn.addEventListener("click", function () { set(!open); });
    close.addEventListener("click", function () { set(false); });
    dr.addEventListener("click", function (e) { if (e.target.closest("a")) set(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && open) set(false); });
    window.addEventListener("resize", function () { if (open && window.innerWidth > 1080) set(false); });
  }

  function setupVideos() {
    var vids = document.querySelectorAll("video");
    if (!vids.length) return;
    var io = "IntersectionObserver" in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { rootMargin: "200px 0px", threshold: 0.01 }) : null;
    vids.forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
      v.setAttribute("muted", ""); v.setAttribute("playsinline", ""); v.setAttribute("autoplay", "");
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      if (io) io.observe(v);
    });
    var kick = function () {
      vids.forEach(function (v) { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
    };
    ["touchstart", "click", "scroll"].forEach(function (ev) {
      window.addEventListener(ev, kick, { once: true, passive: true });
    });
    document.addEventListener("visibilitychange", function () { if (!document.hidden) kick(); });
  }

  function setupUnderlines() {
    var noLine = !!document.querySelector("[data-carousel]");
    document.querySelectorAll("[data-cell]").forEach(function (el) {
      if (el.querySelector("[data-underline]")) return;
      if (noLine) {
        var ar = el.querySelector("[data-cellarrow]");
        if (ar) {
          el.addEventListener("mouseenter", function () { ar.style.transform = "translate(8px,0)"; ar.style.color = "#ff6a00"; });
          el.addEventListener("mouseleave", function () { ar.style.transform = "translate(0,0)"; ar.style.color = "#7a7a7d"; });
        }
        return;
      }
      var line = document.createElement("span");
      line.setAttribute("data-underline", "");
      line.style.cssText = "position:absolute; left:0; bottom:-1px; width:100%; height:2px; background:#ff6a00; transform:scaleX(0); transform-origin:left center; transition:transform .7s cubic-bezier(.16,1,.3,1); pointer-events:none;";
      el.appendChild(line);
      el.addEventListener("mouseenter", function () { line.style.transform = "scaleX(1)"; });
      el.addEventListener("mouseleave", function () { line.style.transform = "scaleX(0)"; });
      var a = el.querySelector("[data-cellarrow]");
      if (a) {
        el.addEventListener("mouseenter", function () { a.style.transform = "translate(8px,0)"; a.style.color = "#ff6a00"; });
        el.addEventListener("mouseleave", function () { a.style.transform = "translate(0,0)"; a.style.color = "#7a7a7d"; });
      }
    });
    document.querySelectorAll("[data-region]").forEach(function (r) {
      r.addEventListener("mouseenter", function () { r.style.paddingLeft = "18px"; });
      r.addEventListener("mouseleave", function () { r.style.paddingLeft = "0px"; });
    });
  }

  function setupGallery() {
    var main = document.querySelector("[data-mainimg]");
    var thumbs = Array.prototype.slice.call(document.querySelectorAll("[data-thumb]"));
    if (!main || !thumbs.length) return;
    var mark = function (active) {
      thumbs.forEach(function (t) { t.style.outline = t === active ? "2px solid #ff6a00" : "none"; t.style.outlineOffset = "-2px"; });
    };
    mark(thumbs[0]);
    thumbs.forEach(function (t) {
      t.addEventListener("click", function (e) {
        e.preventDefault();
        main.style.opacity = "0";
        setTimeout(function () { main.src = t.getAttribute("data-src"); main.style.opacity = "1"; }, 180);
        mark(t);
      });
    });
    main.style.transition = "opacity .3s ease";
  }

  function setupForm() {
    var q = new URLSearchParams(window.location.search);
    var doc = q.get("doc");
    if (!doc) return;
    var motivo = document.querySelector('[data-f="Motivo"]');
    if (motivo) {
      for (var k = 0; k < motivo.options.length; k++) {
        if (/documentaci/i.test(motivo.options[k].text)) { motivo.selectedIndex = k; break; }
      }
    }
    var body = document.querySelector('[data-f="Requerimiento"]');
    if (body && !body.value) {
      body.value = "Solicito el siguiente documento: " + doc + ".";
      body.style.borderBottomColor = "#ff6a00";
    }
    var note = document.querySelector("[data-formnote]");
    if (note) { note.textContent = "Documento solicitado: " + doc; note.style.color = "#ff6a00"; }
  }

  function setupDocs() {
    var btns = Array.prototype.slice.call(document.querySelectorAll("[data-filter]"));
    var docs = Array.prototype.slice.call(document.querySelectorAll("[data-doc]"));
    var count = document.querySelector("[data-doc] ~ [data-count], [data-count]:not([data-suffix]):not([data-prefix])");
    var empty = document.querySelector("[data-empty]");
    if (!btns.length || !docs.length) return;
    var pad = function (n) { return n < 10 ? "0" + n : String(n); };
    var apply = function (cat) {
      var shown = 0;
      docs.forEach(function (d) {
        var on = cat === "todos" || d.getAttribute("data-cat") === cat;
        d.style.display = on ? "grid" : "none";
        if (on) shown++;
      });
      if (count) count.textContent = pad(shown) + (shown === 1 ? " documento" : " documentos");
      if (empty) empty.style.display = shown ? "none" : "block";
      btns.forEach(function (b) {
        var active = b.getAttribute("data-filter") === cat;
        b.style.background = active ? "#ff6a00" : "transparent";
        b.style.borderColor = active ? "#ff6a00" : "rgba(242,242,243,.24)";
        b.style.color = active ? "#0e0f10" : "#b7b7ba";
      });
    };
    btns.forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); apply(b.getAttribute("data-filter")); }); });
    docs.forEach(function (d) {
      d.addEventListener("mouseenter", function () { d.style.paddingLeft = "16px"; });
      d.addEventListener("mouseleave", function () { d.style.paddingLeft = "0px"; });
    });
    apply("todos");
  }

  function setupCounters() {
    var els = Array.prototype.slice.call(document.querySelectorAll("[data-count]")).filter(function (el) {
      return /^\d+$/.test((el.getAttribute("data-count") || "").trim());
    });
    if (!els.length || !("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        var target = parseInt(e.target.getAttribute("data-count"), 10) || 0;
        var suffix = e.target.getAttribute("data-suffix") || "";
        var prefix = e.target.getAttribute("data-prefix") || "";
        var t0 = performance.now(), dur = 1400;
        var step = function (now) {
          var p = Math.min(1, (now - t0) / dur);
          e.target.textContent = prefix + Math.round(target * (1 - Math.pow(1 - p, 3))) + suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { obs.observe(el); });
  }

  function setupServicePanels() {
    var panels = Array.prototype.slice.call(document.querySelectorAll("[data-panel-svc]"));
    if (!panels.length) return;
    var wide = function () { return window.innerWidth > 1080; };
    var setSvc = function (active) {
      panels.forEach(function (p, n) {
        var on = n === active;
        var more = p.querySelector("[data-svcmore]");
        var rule = p.querySelector("[data-svcrule]");
        var arrow = p.querySelector("[data-svcarrow]");
        if (!wide()) { p.style.flexGrow = ""; p.style.background = "transparent"; if (more) { more.style.maxHeight = ""; more.style.opacity = ""; } return; }
        p.style.flexGrow = active === -1 ? "1" : (on ? "2.1" : "0.72");
        p.style.background = on ? "rgba(242,242,243,.04)" : "transparent";
        if (more) { more.style.maxHeight = on ? "260px" : "0px"; more.style.opacity = on ? "1" : "0"; }
        if (rule) rule.style.width = on ? "80px" : "26px";
        if (arrow) arrow.style.transform = on ? "translate(5px,-5px)" : "translate(0,0)";
      });
    };
    panels.forEach(function (p, n) {
      p.addEventListener("mouseenter", function () { setSvc(n); });
      p.addEventListener("focusin", function () { setSvc(n); });
    });
    var group = document.querySelector("[data-svcgroup]");
    if (group) group.addEventListener("mouseleave", function () { setSvc(-1); });
    setSvc(-1);
    window.addEventListener("resize", function () { setSvc(-1); }, { passive: true });
  }

  function setupCarousel() {
    var root = document.querySelector("[data-carousel]");
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-slide]"));
    if (!slides.length) return;
    slides.forEach(function (sl) {
      var img = sl.querySelector("[data-slideimg]");
      var foot = sl.querySelector("[data-slidefoot]");
      var title = sl.querySelector("h3");
      if (title) title.style.transition = "font-size .6s cubic-bezier(.16,1,.3,1), letter-spacing .6s ease";
      sl.addEventListener("mouseenter", function () {
        if (img) { img.style.transform = "scale(1.08)"; img.style.filter = "grayscale(.05) contrast(1.04) brightness(.86)"; }
        if (foot) { foot.style.opacity = "1"; foot.style.transform = "translateY(0)"; }
        if (title) title.style.fontSize = "clamp(26px,3.9vh,38px)";
        sl.style.borderColor = "#ff6a00";
        if (sl.__baseW !== window.innerWidth) { sl.__baseW = window.innerWidth; sl.__baseH = sl.getBoundingClientRect().height; }
        sl.style.setProperty("min-height", Math.round(sl.__baseH * 1.32) + "px", "important");
        sl.style.zIndex = "4";
      });
      sl.addEventListener("mouseleave", function () {
        if (img) { img.style.transform = "scale(1.04)"; img.style.filter = "grayscale(1) contrast(1.06) brightness(.58)"; }
        if (foot) { foot.style.opacity = ".55"; foot.style.transform = "translateY(6px)"; }
        if (title) title.style.fontSize = "";
        sl.style.borderColor = "rgba(242,242,243,.18)";
        sl.style.removeProperty("min-height");
        sl.style.zIndex = "";
      });
    });
  }

  function introHero() {
    var seen = [];
    Array.prototype.slice.call(document.querySelectorAll("[data-hlineinner]")).filter(function (el) {
      if (seen.indexOf(el) >= 0) return false; seen.push(el); return true;
    }).forEach(function (el, i) {
      el.style.transform = "translateY(110%)";
      el.style.opacity = "0";
      el.style.transition = "transform 1.05s cubic-bezier(.16,1,.3,1) " + (0.15 + i * 0.11) + "s, opacity .8s ease " + (0.15 + i * 0.11) + "s";
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.style.transform = "translateY(0)"; el.style.opacity = "1"; }); });
    });
  }

  function setupHeadings() {
    document.querySelectorAll("[data-reveal] > div > h2, [data-reveal] h2").forEach(function (h) {
      if (h.closest("[data-prod]")) return;
      var parts = [];
      Array.prototype.slice.call(h.childNodes).forEach(function (n) {
        if (n.nodeType === 3) parts = parts.concat(n.textContent.split(/(\s+)/).filter(function (t) { return t.length; }));
        else if (n.tagName === "BR") parts.push("\n");
        else parts.push(n.textContent);
      });
      if (!parts.length) return;
      h.textContent = "";
      parts.forEach(function (p) {
        if (p === "\n") { h.appendChild(document.createElement("br")); return; }
        if (!p.trim()) { h.appendChild(document.createTextNode(" ")); return; }
        var mask = document.createElement("span");
        mask.style.display = "inline-block";
        mask.style.overflow = "hidden";
        mask.style.verticalAlign = "bottom";
        mask.style.paddingTop = ".14em";
        mask.style.marginTop = "-.14em";
        var inner = document.createElement("span");
        inner.setAttribute("data-word", "");
        inner.style.display = "inline-block";
        inner.style.transform = "translateY(105%)";
        inner.style.transition = "transform 1s cubic-bezier(.16,1,.3,1)";
        inner.textContent = p;
        mask.appendChild(inner);
        h.appendChild(mask);
        h.appendChild(document.createTextNode(" "));
      });
    });
  }

  function setupReveals() {
    var ease = "cubic-bezier(.16,1,.3,1)";
    var els = Array.prototype.slice.call(document.querySelectorAll("[data-reveal]"));
    els.forEach(function (el) {
      el.style.opacity = "0";
      el.style.transform = "translate3d(0," + (40 * K) + "px,0)";
      el.style.transition = "opacity 1s " + ease + ", transform 1.15s " + ease;
      if (el.hasAttribute("data-wipe") || el.hasAttribute("data-stagger")) {
        Array.prototype.slice.call(el.children).forEach(function (c, i) {
          if (el.hasAttribute("data-wipe")) {
            c.style.clipPath = "inset(0 0 100% 0)";
            c.style.transition = "clip-path 1.1s " + ease + " " + (i * 0.14) + "s, transform 1.1s " + ease + " " + (i * 0.14) + "s";
          } else {
            c.style.opacity = "0";
            c.style.transition = "opacity .7s ease " + (i * 0.11) + "s, transform .95s " + ease + " " + (i * 0.11) + "s";
          }
          c.style.transform = "translate3d(0," + (24 * K) + "px,0)";
        });
      }
    });
    var show = function (el) {
      el.style.opacity = "1";
      el.style.transform = "translate3d(0,0,0)";
      el.querySelectorAll("[data-word]").forEach(function (wd, i) {
        wd.style.transitionDelay = (0.04 + i * 0.045) + "s";
        wd.style.transform = "translateY(0)";
      });
      if (el.hasAttribute("data-wipe") || el.hasAttribute("data-stagger")) {
        Array.prototype.slice.call(el.children).forEach(function (c) {
          c.style.opacity = "1";
          c.style.transform = "translate3d(0,0,0)";
          if (el.hasAttribute("data-wipe")) c.style.clipPath = "inset(0 0 0% 0)";
        });
      }
    };
    if (!("IntersectionObserver" in window)) { els.forEach(show); return; }
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (e.isIntersecting) { setTimeout(function () { show(e.target); }, i * 70); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { if (el.style.opacity === "0") show(el); }); }, 4500);
  }

  function tick() {
    var y = window.scrollY || 0, vh = window.innerHeight;
    if (timeline && tlfill) {
      var tr = timeline.getBoundingClientRect();
      var tp = Math.min(1, Math.max(0, (vh * 0.72 - tr.top) / tr.height));
      tlfill.style.height = (tp * 100) + "%";
    }
    if (bar) {
      var max = document.documentElement.scrollHeight - vh;
      bar.style.width = (max > 0 ? (y / max) * 100 : 0) + "%";
    }
    if (nav) {
      var down = y > lastY + 4, up = y < lastY - 4;
      if (down && y > vh * 0.6 && !navHidden) { navHidden = true; nav.style.transform = "translate3d(0,-100%,0)"; }
      else if (up && navHidden) { navHidden = false; nav.style.transform = "translate3d(0,0,0)"; }
      lastY = y;
    }
    parallax.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      var amt = parseFloat(el.getAttribute("data-parallax")) || 0.15;
      var rel = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = "translate3d(0," + (-rel * amt * 240 * K) + "px,0)";
    });
  }

  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; tick(); });
  }

  function start() {
    nav = document.querySelector("[data-nav]");
    bar = document.querySelector("[data-progress]");
    timeline = document.querySelector("[data-timeline]");
    tlfill = document.querySelector("[data-tlfill]");
    parallax = Array.prototype.slice.call(document.querySelectorAll("[data-parallax]"));
    lastY = window.scrollY || 0;
    introHero();
    setupHeadings();
    setupReveals();
    setupMenus();
    setupCards();
    setupUnderlines();
    setupVideos();
    setupMobileNav();
    setupGallery();
    setupForm();
    setupDocs();
    setupCounters();
    setupServicePanels();
    setupCarousel();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    tick();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  // El editor de tema recarga secciones sin recargar la página: re-inicializar.
  document.addEventListener("shopify:section:load", function () { setTimeout(start, 30); });
  document.addEventListener("shopify:section:reorder", function () { setTimeout(start, 30); });
})();
